export default {
  async call(url, options) {
    const response = await fetch(url, options);
    if (response.ok) {
      return await response.json();
    }
    await this.handleError(response);
  },
  async callWithNoReturnJson(url, options) {
    const response = await fetch(url, options);
    if (response.ok) {
      return;
    }
    await this.handleError(response);
  },
  async callForFileDownload(url, options, fileName) {
    const response = await fetch(url, options);
    if (response.ok) {
      const blob = await response.blob();
      const fileUrl = URL.createObjectURL(blob);
      const fileLink = document.createElement('a');
      fileLink.href = fileUrl;
      fileLink.setAttribute('download', fileName);
      document.body.appendChild(fileLink);
      fileLink.click();
      return;
    }
    await this.handleError(response);
  },
  async callForPhoto(url, options) {
    const response = await fetch(url, options);
    if (response.ok) {
      let blob = await response.blob();
      return URL.createObjectURL(blob);
    }
    await this.handleError(response);
  },
  async handleError(response) {
    switch (response.status) {
      case 401:
        throw new Error(`${response.status}: Unauthorized`);
      case 400:
      case 500: {
        const error = await response.json();
        if (error) {
          throw new Error(`${error.title} [${response.status}]: ${error.detail}`);
        }
        throw new Error(`${response.status}: Internal Server Error`);
      }
      default:
        throw new Error(`${response.status}: Internal Server Error`);
    }
  }
}